import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const objections = ['This is not a random collection of drills copied from the internet.', 'This is not a theoretical manual you have to rewrite before it works in a real lesson.', 'This is not content designed for a different type of instructor that you have to completely adapt.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-sage-light relative overflow-hidden" data-id="element-230" data-mp="z2fsastt2304">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-231" data-mp="u2tae6317ykz" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-232" data-mp="183dxvfjw6ikt">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-233" data-mp="1407sea4lsvfe">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/15 text-gold-dark mb-5" data-id="element-234" data-mp="2jjaw5udmeeup">
            <span className="text-2xl" data-id="element-235" data-mp="2bvz54gm436al">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-ink" data-id="element-236" data-mp="2bvfnl10dijx3">
            The Most Complete Pickleball Teaching Library for Instructors Worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-237" data-mp="2kxoulgwfnv5q">
            Pickleball Instructor Ready — A Complete 6-in-1 Teaching System
          </h3>
          <p className="text-base md:text-lg text-charcoal mb-10" data-id="element-238" data-mp="1t5hc0axda8op">
            150 ready-to-teach lessons · 5 Strategic Bonuses · Everything ready to use
            starting today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-239" data-mp="225nmrp1okuk6">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-white p-6 rounded-2xl border border-sage shadow-sm" data-id="element-240" data-mp="2242wibmefxs4">
            {objections.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-241" data-mp="2hr8up4yulilj">
                <X className="text-charcoal/60 shrink-0 mt-1" size={18} data-id="element-242" data-mp="2hpe9dpjnzogx" />
                <p className="text-charcoal text-sm" data-id="element-243" data-mp="2cr2v92mc6rsw">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-forest p-6 rounded-2xl border border-gold/40 relative overflow-hidden" data-id="element-244" data-mp="2qir8xac8hobz">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-245" data-mp="1tu1slog993s4" />
            <div className="flex items-start gap-3 relative z-10" data-id="element-246" data-mp="27tb78jotbptz">
              <Check className="text-gold-light shrink-0 mt-1" size={20} data-id="element-247" data-mp="22ty8p1okwubk" />
              <p className="text-cream-light font-medium text-base leading-relaxed" data-id="element-248" data-mp="22sn97e2628q9">
                This is a complete professional 6-in-1 teaching system — so you walk into
                every lesson completely prepared, confident, and ready to deliver a session
                your players will actually feel.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}